import { OperatorId } from './config/OperatorId';
import { IOperator } from './types/IOperator';
import { ref } from 'vue';

export type Operator = IOperator;

export const operatorRepositoryName = 'operatorRepository';

export function useOperatorRepository() {
    return {
        operators: ref<IOperator[]>([]),
    };
}

export {
    OperatorId,
    IOperator,
};